import http from "@/services/api.service";
import ISes from "@/types/ses.interface";
import UserService from "@/services/user.service";
import IHelpData from "@/types/helpData.interface";

class SesService {
    sendHelp(params: IHelpData, email: any) {
            params.email = email;
                    params.firstname = params.firstname == null ? 'Non renseigné' : params.firstname;
                    const body: ISes = {
                        recipient: process.env.VUE_APP_CONTACT,
                        data: params,
                        template: 5,
                    };
                    return http.post('/ses/template-mail', body,
                        {
                            headers: {'Content-Type': 'application/json'}
                        }
                    );
    }

    uploadFile(file: File) {
        const formData = new FormData();
        formData.append("file", file);
        return http.post('/preference/filerepeller', formData,
            {
                headers: { 'Content-Type': 'multipart/form-data' }
            }
        );
    }
}
export default new SesService;
